module.exports = __webpack_public_path__ + "static/1-f29685d2eb07deaf088ebb74fa1cbd39.png";